import { useState } from 'react';
import { Box, Icon, Table } from '@quintoandar-tokko/jopijs';
import parentStyles from '../dashboardTables.module.scss';
import specificStyles from './styles.module.scss';

export default function CollapsibleRow({ items, children, ...rest }) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <>
      <Table.RowDefault
        variant="secondary"
        className={specificStyles.collapsibleRow}
        onClick={() => setIsOpen((prevState) => !prevState)}
        {...rest}
      >
        {items.map((item, index) => (
          <Table.RowItemDefault
            // eslint-disable-next-line
            key={index}
            className={parentStyles.tableBodyCell}
          >
            <Box className={specificStyles.collapsibleCellContent}>{item}</Box>
          </Table.RowItemDefault>
        ))}

        <Icon
          icon={isOpen ? 'icon-colapsar' : 'icon-dropdown'}
          className={specificStyles.collapsibleRowIcon}
        />
      </Table.RowDefault>
      <Box className={specificStyles.collapsibleRowSeparator} />

      {isOpen && children}
    </>
  );
}
